/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotificationPolicyConfigWebhook {
  /**
  * The URL of the webhook endpoint
  */
  'url'?: string;
  /**
  * Custom headers (e.g., Authorization)
  */
  'headers'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "url",
      "baseName": "url",
      "type": "string",
      "format": ""
    },
    {
      "name": "headers",
      "baseName": "headers",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfigWebhook.attributeTypeMap;
  }

  public constructor() {
  }
}

